import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const ContentQueueItem = ({ 
  content, 
  onReview, 
  onApprove, 
  onFlag,
  onAIAnalysis = () => {}
}) => {
  const getRiskColor = (level) => {
    switch (level) {
      case 'high':
        return 'text-error bg-error/10 border-error/20';
      case 'medium':
        return 'text-warning bg-warning/10 border-warning/20';
      case 'low':
        return 'text-success bg-success/10 border-success/20';
      default:
        return 'text-muted-foreground bg-muted border-border';
    }
  };

  const getPlatformIcon = (platform) => {
    switch (platform?.toLowerCase()) {
      case 'facebook':
        return 'Facebook';
      case 'twitter':
        return 'Twitter';
      case 'linkedin':
        return 'Linkedin';
      case 'instagram':
        return 'Instagram';
      case 'website':
        return 'Globe';
      default:
        return 'MessageSquare';
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'approved':
        return 'text-success bg-success/10';
      case 'flagged':
        return 'text-error bg-error/10';
      case 'pending':
        return 'text-warning bg-warning/10';
      default:
        return 'text-muted-foreground bg-muted';
    }
  };

  return (
    <div className="flex items-start space-x-4">
      {/* Content Preview */}
      <div className="flex-shrink-0">
        {content?.thumbnail ? (
          <div className="w-16 h-16 rounded-lg overflow-hidden">
            <Image 
              src={content?.thumbnail} 
              alt="Content preview"
              className="w-full h-full object-cover"
            />
          </div>
        ) : (
          <div className="w-16 h-16 bg-muted rounded-lg flex items-center justify-center">
            <Icon name="FileText" size={24} className="text-muted-foreground" />
          </div>
        )}
      </div>

      {/* Content Details */}
      <div className="flex-1 min-w-0">
        <div className="flex items-center space-x-2 mb-2">
          <Icon name={getPlatformIcon(content?.platform)} size={16} className="text-muted-foreground" />
          <span className="text-sm font-medium text-foreground">{content?.platform}</span>
          <span className={`px-2 py-1 rounded-full text-xs font-medium border ${getRiskColor(content?.riskLevel)}`}>
            {content?.riskLevel?.toUpperCase()} RISK
          </span>
          <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(content?.status)}`}>
            {content?.status?.toUpperCase()}
          </span>
        </div>
        
        <p className="text-sm text-foreground mb-2 line-clamp-2">
          {content?.preview}
        </p>
        
        <div className="flex items-center space-x-4 text-xs text-muted-foreground">
          <span>Created: {content?.createdAt}</span>
          <span>Score: {content?.complianceScore}/100</span>
          {content?.violations > 0 && (
            <span className="text-error">{content?.violations} violations</span>
          )}
        </div>
      </div>

      {/* Actions */}
      <div className="flex flex-col space-y-2 min-w-0">
        <div className="flex flex-wrap gap-2">
          <Button
            size="sm"
            variant="outline"
            iconName="Brain"
            onClick={() => onAIAnalysis(content)}
            className="text-purple-600 border-purple-200 hover:bg-purple-50"
          >
            AI Check
          </Button>
          <Button
            size="sm"
            variant="outline"
            iconName="Eye"
            onClick={() => onReview(content?.id)}
          >
            Review
          </Button>
          <Button
            size="sm"
            variant={content?.status === 'approved' ? 'default' : 'outline'}
            iconName="Check"
            onClick={() => onApprove(content?.id)}
            disabled={content?.status === 'approved'}
            className={content?.status === 'approved' ? 'bg-green-600' : ''}
          >
            Approve
          </Button>
          <Button
            size="sm"
            variant={content?.status === 'flagged' ? 'destructive' : 'outline'}
            iconName="Flag"
            onClick={() => onFlag(content?.id)}
            disabled={content?.status === 'flagged'}
          >
            Flag
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ContentQueueItem;